<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card mb-3">
        <div class="card-body">
          <form-navigation-tabs
            :tabs="tabs"
            v-on:selected="setActive"
            :active="currentView"
          ></form-navigation-tabs>
          <transition name="component-fade" mode="out-in">
            <incident-source
              :incident="incident"
              :showCancel="false"
              v-on:created="activateTabs"
              v-on:exists="activateTabs"
              v-if="currentView == 'source'"
              v-on:unsaved-data="saveStatus"
            ></incident-source>
            <client-details
              :incident="incident"
              v-if="currentView == 'client_details'"
              v-on:unsaved-data="saveStatus"
            ></client-details>

            <client-vehicle
              :incident="incident"
              v-if="currentView == 'client_vehicle'"
              v-on:unsaved-data="saveStatus"
            ></client-vehicle>

            <vehicle-location
              :incident="incident"
              v-if="currentView == 'vehicle_location'"
              v-on:unsaved-data="saveStatus"
            ></vehicle-location>

            <client-insurance
              :incident="incident"
              v-if="currentView == 'client_insurance'"
              v-on:unsaved-data="saveStatus"
            >
            </client-insurance>

            <occupants
              :incident="incident"
              v-if="currentView == 'occupants'"
            ></occupants>

            <accident-details
              :incident="incident"
              v-if="currentView == 'accident_details'"
              v-on:unsaved-data="saveStatus"
            ></accident-details>

            <third-party-details
              :incident="incident"
              v-if="currentView == 'third_party_details'"
              v-on:unsaved-data="saveStatus"
            ></third-party-details>

            <third-party-vehicle
              :incident="incident"
              v-if="currentView == 'third_party_vehicle'"
              v-on:unsaved-data="saveStatus"
            ></third-party-vehicle>

            <witnesses
              :incident="incident"
              v-if="currentView == 'witnesses'"
            ></witnesses>

            <hire
              :incident="incident"
              v-if="currentView == 'hire'"
              :hide-button="true"
              v-on:unsaved-data="saveStatus"
            ></hire>
          </transition>
        </div>
        <div class="card-footer text-right" v-if="currentView == 'details'">
          <button
            class="btn btn-primary btn-raised"
            name="save"
            v-on:click.prevent="submit"
          >
            <i class="icon icon-save"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Source from '../FirstNoticeOfLoss/Sections/Source.vue';
import ClientDetails from '../FirstNoticeOfLoss/Sections/ClientDetails.vue';
import ClientVehicle from '../FirstNoticeOfLoss/Sections/ClientVehicle.vue';
import VehicleLocation from '../FirstNoticeOfLoss/Sections/VehicleLocation.vue';
import ClientInsurance from '../FirstNoticeOfLoss/Sections/ClientInsurance.vue';
import Occupants from '../FirstNoticeOfLoss/Sections/Occupants.vue';
import AccidentDetails from '../FirstNoticeOfLoss/Sections/AccidentDetails.vue';
import ThirdPartyDetails from '../FirstNoticeOfLoss/Sections/ThirdPartyDetails.vue';
import ThirdPartyVehicle from '../FirstNoticeOfLoss/Sections/ThirdPartyVehicle.vue';
import Witnesses from '../FirstNoticeOfLoss/Sections/Witnesses.vue';
import Hire from '../FirstNoticeOfLoss/Sections/Hire.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'incident-source': Source,
    'client-details': ClientDetails,
    'client-vehicle': ClientVehicle,
    'vehicle-location': VehicleLocation,
    'client-insurance': ClientInsurance,
    occupants: Occupants,
    'accident-details': AccidentDetails,
    'third-party-details': ThirdPartyDetails,
    'third-party-vehicle': ThirdPartyVehicle,
    witnesses: Witnesses,
    hire: Hire
  },

  data() {
    return {
      currentView: 'source',
      unsaved_data: false,
      tabs: [
        {
          name: 'source',
          label: 'Source',
          disabled: false
        },
        {
          name: 'client_details',
          label: 'Client Details',
          disabled: true
        },
        {
          name: 'client_vehicle',
          label: 'Client Vehicle',
          disabled: true
        },
        {
          name: 'vehicle_location',
          label: 'Vehicle Location',
          disabled: true
        },
        {
          name: 'client_insurance',
          label: 'Client Insurance',
          disabled: true
        },
        {
          name: 'occupants',
          label: 'Occupants',
          disabled: true
        },
        {
          name: 'accident_details',
          label: 'Accident Details',
          disabled: true
        },
        {
          name: 'third_party_details',
          label: 'TP Details',
          disabled: true
        },
        {
          name: 'third_party_vehicle',
          label: 'TP Vehicle',
          disabled: true
        },
        {
          name: 'witnesses',
          label: 'Witnesses',
          disabled: true
        },
        {
          name: 'hire',
          label: 'Hire',
          disabled: true
        }
      ]
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },

    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;
      }
    },

    activateTabs() {
      this.tabs.forEach(tab => {
        tab.disabled = false;
      });
    },

    saveStatus(event) {
      this.unsaved_data = event;
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    }
  }
};
</script>
